import React from "react";
import { getAll } from "../api/people"

  

const PeopleDetailsPage = () => {
  return (
    <>
      <h1>People Details Page</h1>
    </>
  );
};
export default PeopleDetailsPage;

// class PeopleDetailsPage extends React.Component {
//   state = {
//     people: [],
//     page: 0,
//   };

//   componentDidMount() {
//     this.updatePageFromURL();
//   }

//   componentDidUpdate() {
//     this.updatePageFromURL();
//   }

//   updatePageFromURL() {
//     const { location } = this.props;
//     const urlParams = new URLSearchParams(location.search);
//     const page = +urlParams.get('page') || 1;

//     if (page === this.state.page) {
//       return;
//     }

//     this.setState({ page }, this.loadPeople);
//   }

//   loadPeople = async () => {
//       const {page} = this.state;
//       const { count, results: people} = await peopleApi.getAll({page});
  
//         this.setState({
//           people,
//           count,
//           isLoaded: true,
//         });
//   }
    
//     render() {
//       return (
//         <div>
//            <span>  People Details Page </span>
//              {this.state.name}
//         </div>
//         )
//     }
// }

// export default PeopleDetailsPage


